import clsx from 'clsx'
import { ReactComponent as LoaderSvg } from 'images/loader.svg'

import style from './Loader.module.css'

const Loader = ({ className }: { className?: string }) => (
  <div className={clsx(style.loader, className)}>
    <div className={style.inner}>
      <LoaderSvg />
    </div>
  </div>
)

export default Loader
